<template style="width: 100vw;height: 100vw;">
    <div v-if="!isMobile && isOpen" class="form-popup" id="confirmation_popup">
        <div class="center-screen">
            <div class="popup-grid" id="confirmation_popup_centered">
                <div class="popup-cell formpopupheader" style="grid-column: 1 / span 16; grid-row: 1; color: #FFF; margin-top: 0px; padding-left: calc(1vw + 10px);">ПОДТВЕРЖДЕНИЕ ЗАКАЗА</div>

                <div class="popup-cell increase-margin-left increase-margin-top" style="grid-column: 1 / span 2; grid-row: 2;">
                    <label class="formboldlabel">Заказчик:</label>
                </div>
                <div class="popup-cell increase-margin-top" style="grid-column: 3 / span 14; grid-row: 2;">
                    <label class="formnormlabel">{{order.fio}}, т. {{order.phone}}, e-mail: {{order.email}}</label>
                </div>

                <div class="popup-cell increase-margin-left" style="grid-column: 1 / span 2; grid-row: 3;">
                    <label class="formboldlabel">Пациент:</label>
                </div>
                <div class="popup-cell" style="grid-column: 3 / span 14; grid-row: 3;">
                    <label class="formnormlabel">
                        {{order.gender=='male' ? 'М' : 'Ж'}}, {{order.isPregnant ? 'беременная, ' : ''}} {{order.weight}} кг, {{order.isAdult ? 'взрослый' : 'ребёнок'}},
                        {{order.mobility=='lying' ? ('лежачий' + (order.mobilitySit ? ' (присаживается)' : ''))+',' : ''}}
                        {{order.mobility=='wheelchair' ? 'на кресле-коляске, ' : ''}}
                        {{order.mobility=='moving' ? 'передвигается самостоятельно, ' : ''}}
                        состояние {{order.state=='ok' ? 'удовлетворительное' : ''}} {{order.state=='average' ? 'средней тяжести' : ''}} {{order.state=='serious' ? 'крайне тяжёлое' : ''}}
                    </label>
                </div>

                <div class="popup-cell increase-margin-left" :style="{'grid-column': '1 / span 2', 'grid-row': '4 / span ' + order.addresses.length}">
                    <label class="formboldlabel" style="display: grid; text-align: center; align-items: center;">
                        <img v-if="order.transport == 'car'" class="orderdata_transport_img" src="@/assets/IMGS/SVG/car/car2_green.svg">
                        <img v-if="order.transport == 'train'" class="orderdata_transport_img" src="@/assets/IMGS/SVG/railway/railway2_green.svg">
                        <img v-if="order.transport == 'plane'" class="orderdata_transport_img" src="@/assets/IMGS/SVG/airplane/airplane2_green.svg">
                        <img v-if="order.transport == 'ship'" class="orderdata_transport_img" src="@/assets/IMGS/SVG/boat/boat2_green.svg">
                    </label>
                </div>
                <div v-for="(addr, index) in order.addresses" :key="index" class="popup-cell" :style="{'grid-column': '3 / span 14', 'grid-row': (index + 4)}">
                  <div style="display: flex;">
                    <label class="formnormlabel" style="font-weight: bold; white-space: nowrap;;">
                        {{index == 0 ? 'Откуда забрать: ' : ''}}
                        {{(index > 0 && index < order.addresses.length - 1) ? 'Остановка: ' : ''}}
                        {{index == order.addresses.length - 1 ? 'Куда доставить: ' : ''}}
                    </label>
                    <label class="formnormlabel">
                        {{addr.value}},
                        {{addr.floor ? addr.floor + ' этаж' : 'этаж не указан'}}
                        {{(addr.floor=='' && addr.floor!='1') ? '' : ', ' + (!addr.isElevator ? 'нет лифта' : (addr.isCargo ? 'есть грузовой лифт' : 'есть лифт, нет грузового'))}}
                    </label>
                  </div>
                </div>

                <div class="popup-cell increase-margin-left" :style="{'grid-column': '1 / span 2', 'grid-row': order.addresses.length+4}">
                    <label class="formboldlabel">Когда:</label>
                </div>
                <div class="popup-cell" :style="{'grid-column': '3 / span 14', 'grid-row': order.addresses.length+4}">
                    <label class="formnormlabel">{{tools.timeInString(order.when) + " " + tools.dateInString(order.when)}}, {{order.oneWay ? 'только туда' : 'туда и обратно' + (order.wait ? ', ожидать '+order.waitTime+' часов' : '')}}</label>
                </div>

                <div v-if="order.comment" class="popup-cell increase-margin-left" :style="{'grid-column': '1 / span 2', 'grid-row': order.addresses.length+5}">
                    <label class="formboldlabel">Комментарий:</label>
                </div>
                <div v-if="order.comment" class="popup-cell" :style="{'grid-column': '3 / span 14', 'grid-row': order.addresses.length+5}">
                    <label class="formnormlabel">{{order.comment}}</label>
                </div>

                <div v-if="order.specificOwner" class="popup-cell increase-margin-left" :style="{'grid-column': '1 / span 2', 'grid-row': order.addresses.length+5}">
                    <label class="formboldlabel">Перевозчик:</label>
                </div>
                <div v-if="order.specificOwner" class="popup-cell" :style="{'grid-column': '3 / span 14', 'grid-row': order.addresses.length+5}">
                    <label class="formnormlabel">{{order.specificOwnerName}}</label>
                </div>

                <div class="popup-cell increase-margin-top" :style="{'grid-column': '3 / span 14', 'grid-row': order.addresses.length+7, 'padding-right': '0px'}">
                  <div style="display: flex; padding-left: 2px;">
                    <CheckboxGroup style="padding-right: 0px; margin-top: -3px;" name="checkall" type="checkbox" checkboxesClass="checkbox" :checkboxes="checkallCheckboxes" maxSelected="1" requiredCount="0"/>
                    <label class="formnormlabel" style="color: var(--color-grey); padding-left: 0px;">Отметить все</label>
                  </div>
                </div>
                <div class="popup-cell" :style="{'grid-column': '3 / span 14', 'grid-row': order.addresses.length+8, 'padding-right': '0px'}">
                  <div style="display: flex; padding-left: 40px;">
                    <CheckboxGroup style="padding-right: 0px; margin-top: -3px;" name="check1" type="checkbox" checkboxesClass="checkbox" :checkboxes="check1Checkboxes" maxSelected="1" requiredCount="1"/>
                    <label class="formnormlabel" style="color: var(--color-grey); padding-left: 0px;">Я даю свое согласие на обработку <a style="padding-left: 5px;" href="/license.pdf" target="_blank">персональных данных</a></label>
                  </div>
                </div>
                <div class="popup-cell" :style="{'grid-column': '3 / span 14', 'grid-row': order.addresses.length+9, 'padding-right': '0px'}">
                  <div style="display: flex; padding-left: 40px;">
                    <CheckboxGroup style="padding-right: 0px; margin-top: -3px;" name="check2" type="checkbox" checkboxesClass="checkbox" :checkboxes="check2Checkboxes" maxSelected="1" requiredCount="1"/>
                    <label class="formnormlabel" style="color: var(--color-grey); padding-left: 0px;">Подтверждаю, что в случае офомления заказа на третьих лиц, предоставляю персональные данные с их согласия</label>
                  </div>
                </div>
                <div class="popup-cell" :style="{'grid-column': '3 / span 14', 'grid-row': order.addresses.length+10, 'padding-right': '0px'}">
                  <div style="display: flex; padding-left: 40px;">
                    <CheckboxGroup style="padding-right: 0px; margin-top: -3px;" name="check3" type="checkbox" checkboxesClass="checkbox" :checkboxes="check3Checkboxes" maxSelected="1" requiredCount="1"/>
                    <label class="formnormlabel" style="color: var(--color-grey); padding-left: 0px;">Подтверждаю достоверность указанной выше информации, необходимой для выполнения заказа</label>
                  </div>
                </div>

                <div class="popup-cell popup-order-buttons-block">
                    <button @click="closeModal()" class="ui-button ui-button--lg ui-button--grey" style="margin-right: 10px;">Вернуться</button>
                    <button @click="successCallback()" class="ui-button ui-button--lg ui-button--secondary" :class="{'ui-button--disabled': !checkallCheckboxes[0].checked}" :disabled="!checkallCheckboxes[0].checked">Заказать</button>
                </div>
            </div>
        </div>
    </div>


    <div v-if="isMobile && isOpen" class="form-popup" id="confirmation_popup">
        <div class="center-screen">
            <div class="popup-grid" style="display: flex; padding-left:25px; text-align: left; flex-flow: column; justify-content: flex-start; align-items: flex-start;" id="confirmation_popup_centered">
                <div class="popup-cell formpopupheader" style="width: 98%; grid-column: 1 / span 16; grid-row: 1; color: #FFF; margin-top: 0px; padding-left: calc(1vw + 10px);">ПОДТВЕРЖДЕНИЕ ЗАКАЗА</div>
                <label class="formboldlabel formmargin" style="display: flex; text-align: center; align-items: center; margin-top: 15px; margin-bottom: 20px;">
                    <img class="orderdata_transport_img" :src="require('@/assets/IMGS/SVG/car/car' + (order.transport == 'car' ? '2_green' : '2_grey') + '.svg')">
                    <img class="orderdata_transport_img" :src="require('@/assets/IMGS/SVG/railway/railway' + (order.transport == 'train' ? '2_green' : '2_grey') + '.svg')">
                    <img class="orderdata_transport_img" :src="require('@/assets/IMGS/SVG/airplane/airplane' + (order.transport == 'plane' ? '2_green' : '2_grey') + '.svg')">
                    <img class="orderdata_transport_img" :src="require('@/assets/IMGS/SVG/boat/boat' + (order.transport == 'ship' ? '2_green' : '2_grey') + '.svg')">
                </label>
                <label class="formboldlabel formmargin">Заказчик:
                    <label class="formnormlabel">{{order.fio}}, т. {{order.phone}}, e-mail: {{order.email}}</label>
                </label>
                <label class="formboldlabel formmargin">Пациент:
                    <label class="formnormlabel">
                        {{order.gender=='male' ? 'М' : 'Ж'}}, {{order.isPregnant ? 'беременная, ' : ''}} {{order.weight}} кг, {{order.isAdult ? 'взрослый' : 'ребёнок'}},
                        {{order.mobility=='lying' ? ('лежачий' + (order.mobilitySit ? ' (присаживается)' : ''))+',' : ''}}
                        {{order.mobility=='wheelchair' ? 'на кресле-коляске, ' : ''}}
                        {{order.mobility=='moving' ? 'передвигается самостоятельно, ' : ''}}
                        состояние {{order.state=='ok' ? 'удовлетворительное' : ''}} {{order.state=='average' ? 'средней тяжести' : ''}} {{order.state=='serious' ? 'крайне тяжёлое' : ''}}
                    </label>
                </label>
                <div class="formmargin" v-for="(addr, index) in order.addresses" :key="index">
                    <label class="formboldlabel">
                        {{index == 0 ? 'Откуда забрать: ' : ''}}
                        {{(index > 0 && index < order.addresses.length - 1) ? 'Остановка: ' : ''}}
                        {{index == order.addresses.length - 1 ? 'Куда доставить: ' : ''}}
                    </label>
                    <label class="formnormlabel">
                        {{addr.value}},
                        {{addr.floor ? addr.floor + ' этаж' : 'этаж не указан'}}
                        {{(addr.floor=='' && addr.floor!='1') ? '' : ', ' + (!addr.isElevator ? 'нет лифта' : (addr.isCargo ? 'есть грузовой лифт' : 'есть лифт, нет грузового'))}}
                    </label>
                </div>
                <label class="formboldlabel formmargin">Когда:
                    <label class="formnormlabel">{{tools.timeInString(order.when) + " " + tools.dateInString(order.when)}}, {{order.oneWay ? 'только туда' : 'туда и обратно' + (order.wait ? ', ожидать '+order.waitTime+' часов' : '')}}</label>
                </label>
                <label class="formboldlabel formmargin">Комментарий к заказу:
                    <label class="formnormlabel">{{order.comment}}</label>
                </label>

                <label class="formmargin" for='checkall' style="display: flex;  align-items: center; width: 100%;">
                    <CheckboxGroup name="checkall" type="checkbox" checkboxesClass="checkbox" :checkboxes="checkallCheckboxes" maxSelected="1" requiredCount="0"/>
                    <label class="formnormlabel" for='checkall' style="margin-top: 8px; color: var(--color-grey);">Отметить все</label>
                </label>
                <label class="formmargin" for='check1' style="margin-left:20px; display: flex;  align-items: center; width: 100%;">
                    <CheckboxGroup name="check1" type="checkbox" checkboxesClass="checkbox" :checkboxes="check1Checkboxes" maxSelected="1" requiredCount="1"/>
                    <label class="formnormlabel" for='check1' style="margin-top: 8px; color: var(--color-grey);">Я даю свое согласие на обработку <a style="padding-left: 5px;" href="/license.pdf" target="_blank">персональных данных</a></label>    |
                </label>
                <label class="formmargin" for='check2' style="margin-left:20px; display: flex;  align-items: center; width: 100%;">
                    <CheckboxGroup name="check2" type="checkbox" checkboxesClass="checkbox" :checkboxes="check2Checkboxes" maxSelected="1" requiredCount="1"/>
                    <label class="formnormlabel" for='check2' style="margin-top: 8px; color: var(--color-grey);">Подтверждаю, что в случае офомления заказа на третьих лиц, предоставляю персональные данные с их согласия</label>
                </label>
                <label class="formmargin" for='check3' style="margin-left:20px; display: flex;  align-items: center; width: 100%;">
                    <CheckboxGroup name="check3" type="checkbox" checkboxesClass="checkbox" :checkboxes="check3Checkboxes" maxSelected="1" requiredCount="1"/>
                    <label class="formnormlabel" for='check3' style="margin-top: 8px; color: var(--color-grey);">Подтверждаю достоверность указанной выше информации, необходимой для выполнения заказа</label>
                </label>
                <div class="formmargin" style="width: 100%; display: flex; flex-flow: column; align-items: center;">
                    <button @click="closeModal()" class="ui-button ui-button--md ui-button--grey" style="width: 70%; margin-top: 20px; margin-right: 10px;">Вернуться</button>
                    <button @click="successCallback()" class="ui-button ui-button--lg ui-button--secondary" :class="{'ui-button--disabled': !checkallCheckboxes[0].checked}" style="width: 70%; margin-top: 20px; margin-right: 10px;" :disabled="!checkallCheckboxes[0].checked">Заказать</button>
                </div>
            </div>
        </div>
    </div>

</template>

<script>
import $ from 'jquery';
import CheckboxGroup from './CheckboxComponent.vue';
import tools from '@/assets/js/tools.js';

export default {
    name: 'PopupOrderCheckDataWindow',
    components: {
         CheckboxGroup,
    },
    data() {
        return { 
            checkallCheckboxes: [
                { id: 'checkall1', name: 'checkall', value: 'true', label: '', checked: false },
            ],
            check1Checkboxes: [
                { id: 'check11', name: 'check1', value: 'true', label: '', checked: false },
            ],
            check2Checkboxes: [
                { id: 'check21', name: 'check2', value: 'true', label: '', checked: false },
            ],
            check3Checkboxes: [
                { id: 'check31', name: 'check3', value: 'true', label: '', checked: false },
            ],
            isMobile: false,
            isOpen: false,
            order: {},
            popup_chbx0: false,
            popup_chbx1: false,
            popup_chbx2: false,
            popup_chbx3: false,
            tools: tools,
        }
    },
    watch: {
      checkallCheckboxes: {
        handler: function(newValue) {
          if (newValue[0].checked || this.check1Checkboxes[0].checked && this.check2Checkboxes[0].checked && this.check3Checkboxes[0].checked) {
            this.check1Checkboxes[0].checked = newValue[0].checked;
            this.check2Checkboxes[0].checked = newValue[0].checked;
            this.check3Checkboxes[0].checked = newValue[0].checked;
          }
        },
        deep: true,
      },
      check1Checkboxes: {
        handler: function(newValue) {
          if (newValue[0].checked && this.check2Checkboxes[0].checked && this.check3Checkboxes[0].checked) this.checkallCheckboxes[0].checked = true;
          if (!newValue[0].checked || !this.check2Checkboxes[0].checked || !this.check3Checkboxes[0].checked) this.checkallCheckboxes[0].checked = false;
        },
        deep: true,
      },
      check2Checkboxes: {
        handler: function(newValue) {
          if (newValue[0].checked && this.check1Checkboxes[0].checked && this.check3Checkboxes[0].checked) this.checkallCheckboxes[0].checked = true;
          if (!newValue[0].checked || !this.check1Checkboxes[0].checked || !this.check3Checkboxes[0].checked) this.checkallCheckboxes[0].checked = false;
        },
        deep: true,
      },
      check3Checkboxes: {
        handler: function(newValue) {
          if (newValue[0].checked && this.check1Checkboxes[0].checked && this.check2Checkboxes[0].checked) this.checkallCheckboxes[0].checked = true;
          if (!newValue[0].checked || !this.check1Checkboxes[0].checked || !this.check2Checkboxes[0].checked) this.checkallCheckboxes[0].checked = false;
        },
        deep: true,
      },
    },
    created(){
        this.isMobile = this.getMobileScreen()
    },
    mounted() {
        var vm = this;
        vm.isMobile = this.getMobileScreen()
    },
    methods: {
        showOrder(data) {
            this.isOpen = true;
            this.order = data;
        },
        closeModal() {
            this.isOpen = false;
        },
        getMobileScreen() {
            if (screen.width <= 1024) {
                return true
            } else {
                return false
            }
        },
        successCallback() {
            var d = this.order; // shortcut
            var parsedAddr = d.addresses.map(addr => {
                return tools.stringToRegAddr(addr.value);
            });
            var addressPoints = d.addresses.map(addr => addr.point);
            var parsedElevators = d.addresses.map(addr => addr.isElevator);
            var parsedCargoElevators = d.addresses.map(addr => addr.isCargo);
            var parsedFloor = d.addresses.map(addr => (addr.floor ? addr.floor : "0"));
            $.ajax({
                type: "POST",
                url: global.BACKEND_URL + "/order/new_order_new_type",
                data: JSON.stringify({
                     accountEmail:'',
                     accountPhone:'',
                     fullname: d.fio,
                     numPhone: d.phone,
                     email: d.email,
                     gender: d.gender,
                     isPregnant: d.isPregnant,
                     weight: d.weight,
                     age: d.isAdult ? 24 : 16,
                     mobility: (d.mobility=="lying" ? "v1" : (d.mobility=="wheelchair" ? "v2" : (d.mobility=="moving" ? "v3" : "ERROR"))),
                     isSit: d.mobilitySit,
                     state: (d.state=="ok" ? "v1" : (d.state=="average" ? "v2" : (d.state=="serious" ? "v3" : "ERROR"))),
                     transport: (d.transport=="car" ? "v1" : (d.transport=="train" ? "v2" : (d.transport=="plane" ? "v3" : (d.transport=="ship" ? "v4" : "ERROR")))),
                     regionFrom: parsedAddr[0][0],
                     regionTo: parsedAddr[parsedAddr.length-1][0],
                     regionsMiddle: parsedAddr.slice(1,parsedAddr.length-1).map(pair => pair[0]),
                     isElevatorFrom: parsedElevators[0],
                     isCargoElevatorFrom: parsedCargoElevators[0],
                     isElevatorTo: parsedElevators[parsedElevators.length-1],
                     isCargoElevatorTo: parsedCargoElevators[parsedCargoElevators.length-1],
                     isElevatorMiddle: parsedElevators.slice(1,parsedAddr.length-1),
                     isCargoElevatorMiddle: parsedCargoElevators.slice(1,parsedAddr.length-1),
                     addressStart: tools.concatPoint(parsedAddr[0][1], addressPoints[0]), // ADDRESS START
                     floorStart: parsedFloor[0],
                     addressEnd: tools.concatPoint(parsedAddr[parsedAddr.length-1][1], addressPoints[parsedAddr.length-1]), // ADDRESS END
                     floorEnd: parsedFloor[parsedFloor.length-1],
                     addressesMiddle: parsedAddr.slice(1,parsedAddr.length-1).map((pair, i) => tools.concatPoint(pair[1], addressPoints[i + 1])), // ADDRESS MIDDLE
                     floorsMiddle: parsedFloor.slice(1,parsedFloor.length-1),
                     onePath: d.oneWay,
                     bothPaths: !d.oneWay,
                     stay: d.wait,
                     timeStay: d.waitTime ? d.waitTime : 0,
                     dateOrder: tools.timeInString(d.when) + " " + tools.dateInString(d.when),
                     comment: "Состояние: " + (d.state=="ok" ? "Удовлетворительное" : (d.state=="average" ? "Средней тяжести" : "Крайне тяжёлое")) +
                              (parsedAddr.length <= 2 ? "" : (", промежуточные адреса: " + parsedAddr.slice(1,parsedAddr.length-1).map(pair => "Регион: " + pair[0] + ", адрес: " + pair[1]))) +
                              (d.mobilitySit ? ", присаживается" : "") +
                              (d.comment == "" ? "" : (", комментарий: " + d.comment)),
                     forAllOwners: !d.specificOwner,
                     nameOwner: d.specificOwnerName,
                }),
                success: function(data){
                    localStorage.justCreatedOrder = "true"
                    document.location = data["orderDataLink"];
                },
                error: function(data){console.log(data);},
                dataType: "json",
                contentType: "application/json"
            });
        },
    }
}
</script>
<style lang="css" scoped src="@/assets/css/order_data.css"></style>

